import { apiPostAsync } from '../common/service-utils';
import * as constants from '../common/constants';

export * from './actionTypes';

export async function sendEmailConfirmationCode(postData) {
    return apiPostAsync(constants.API_REGISTRATION_SEND_EMAIL_CONFIRMATION, null, postData);
}

export async function submitEmailVerificationCode(postData) {
    return apiPostAsync(constants.API_REGISTRATION_VERIFY_EMAIL_CONFIRMATION_CODE, null, postData);
}

export async function allRolesByAppKey(postData) {
    const resp = await apiPostAsync(constants.API_ALL_ROLES_BY_APP_KEY, null, postData);
    resp.data.sort((aRole, bRole) => {
        const aSeq = aRole.roleSequence !== undefined ? parseInt(aRole.roleSequence) : 0;
        const bSeq = bRole.roleSequence !== undefined ? parseInt(bRole.roleSequence) : 0;
        if (aSeq > 0 && bSeq <= 0) return -1;
        if (aSeq <= 0 && bSeq > 0) return 1;
        if (aSeq > 0 && bSeq > 0) return aSeq - bSeq;
        return aRole.roleLabel.toLowerCase().localeCompare(bRole.roleLabel.toLowerCase());
    });
    return resp;
}

export async function getUltimateParentCompanyAllowedRoles(postData) {
    return apiPostAsync(constants.API_GET_ULTIMATE_PARENT_COMPANY_ALLOWED_ROLES, null, postData);
}

export async function getSelfRegistrationAttributes(postData) {
    const reqData = {
        appKeys: [`${postData.appKey}`],
        tags: 'SELF_REGISTRATION_ATTRIBUTE',
        emailAddress: postData.emailAddress,
    };
    return apiPostAsync(constants.GET_ATTRIBUTES_TYPES, null, reqData);
}

export async function submitRegistration(postData) {
    const url = postData.submitAction === 'update' ? constants.API_UPDATE_REGISTRATION : constants.API_SAVE_REGISTRATION;
    return apiPostAsync(url, null, postData);
}

export async function refreshRegistrationSession() {
    return apiPostAsync(constants.API_REGISTRATION_SEND_SESSION_PING, null, {});
}
